<script src="../../../../vue.config.js"></script>
<template>
    <div class="my-promotion" style="padding-top: 1rem">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Promoter management'"
                  path="/user"
        ></navTitle>
        <div v-if="start">
            <!--提交代理申请-->
            <div class="frist" v-if="is_promoter==0 && (apply==''||apply.status==0||apply.status==2)">
                <p class="T1">Menerapkan untuk menjadi agen kami</p>
                <p class="N1">Silakan kirim foto untuk membuktikan kelayakan Anda!</p>
                <div class="btn btn-blue" @click="ConfirmApply">Konfirmasikan</div>
                <div class="tips">Pengunggahan mungkin tertunda, silakan tunggu sebentar dan jangan klik berulang
                    kali！
                </div>
            </div>
            <div class="third" v-if="is_promoter==1">
                <div class="header">
                    <div class="name acea-row row-center-wrapper">
                        <div>Komisi saat ini</div>
                        <router-link class="record" :to="'/user/cashrecord'">
                            Catatan<span class="iconfont icon-xiangyou"></span>
                        </router-link>
                    </div>
                    <div class="num">{{ userInfo.extractPrice || 0 }}
                        <b @click="toDouble" style="font-size: .5rem;">x2</b>
                    </div>
                    <div style="clear: both"></div>
                    <div class="profit acea-row row-between-wrapper">
                        <div class="item">
                            <div>Untung kemarin</div>
                            <div class="money">{{ userInfo.yesterDay || 0 }}</div>
                        </div>
                        <div class="item">
                            <div>Akumulasi Penarikan({{icon_moeny}})</div>
                            <div class="money">{{ userInfo.extractTotalPrice || 0 }}</div>
                        </div>
                    </div>
                </div>
                <div class="bnt bg-color-red" @click="toCash">Penarikan</div>
                <div class="list acea-row row-between-wrapper">
          <span class="item acea-row row-center-wrapper row-column copy-data" :data-clipboard-text="linkText"
                @click="copyLink">
            <span class="iconfont icon-fenxiang"></span>
            <div>Undang teman</div>
          </span>
                    <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/promoter_list'">
                        <span class="iconfont icon-tongji"></span>
                        <div>Total agen</div>
                    </router-link>
                    <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/commission'">
                        <span class="iconfont icon-qiandai"></span>
                        <div>Prestasi promotor</div>
                    </router-link>
                    <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/promoter_order'">
                        <span class="iconfont icon-dingdan"></span>
                        <div>Pesanan promotor</div>
                    </router-link>
                    <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/promoter_rank'">
                        <span class="iconfont icon-paihang1"></span>
                        <div>Peringkat promotor</div>
                        <!--            <div>Daftar hari ini</div>-->
                    </router-link>
                    <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/commission/rank'">
                        <span class="iconfont icon-paihang"></span>
                        <div>Peringkat komisi</div>
                        <!--                        <div>Komisi hari ini</div>-->
                    </router-link>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
    import {getUser, become_anent, promoter_applyInfo} from "../../../api/user";
    import navTitle from "@components/navTitle";
    import ClipboardJS from "clipboard";
    import {VUE_APP_API_URL} from "@utils";
    import VueCoreImageUpload from "vue-core-image-upload";

    export default {
        name: "UserPromotion",
        components: {navTitle, VueCoreImageUpload},
        props: {},
        data: function () {
            return {
                icon_moeny: this.global.moeny,

                start: false,
                userInfo: {},
                linkText: '',
                is_promoter: '',
                apply: "",
                url: `${VUE_APP_API_URL}/upload/image`,
                headers: {
                    "Authori-zation": "Bearer " + this.$store.state.app.token
                },
                updata: "",
                updataYes: false
            };
        },
        mounted: function () {
            this.getInfo();
            promoter_applyInfo().then(res => {
                // console.log('promoter_applyInfo',res)
                this.apply = res.data.apply
                this.start = true
                /*if (res.data.apply.status === 0) {
                  this.$router.push({path: 'login'});
                }*/
            })
                .catch(res => {
                    this.$dialog.error(res.msg)
                })
        },
        methods: {
            ToSubmitAgain() {
                this.updata = ""
                this.updataYes = false
                this.apply = ""
            },
            toDouble() {
                this.$router.push('/commission/activity')
            },
            cancleApply() {
                this.updata = ""
                this.updataYes = false
            },
            ConfirmApply() {
                if (!this.updata) {
                    this.$dialog.error("Upload photo is not exist！")
                }
                this.$dialog.loading.open('loading...')
                become_anent({uid: this.apply.uid}).then(res => {
                    // console.log('promoter_apply',res)
                    this.$dialog.loading.close()
                    this.$dialog.toast({mes: res.msg})
                    setTimeout(function () {
                        window.location.reload()
                    }, 3000)
                })
                    .catch(res => {
                        this.$dialog.loading.close()
                        this.$dialog.toast({mes: res.msg})
                    })
            },
            imageUploadStar() {
                // console.log('aaaaaaa')
                this.$dialog.loading.open('loading...')
            },
            imageUploadEnd() {
                this.$dialog.loading.close()
                this.updataYes = true
            },
            imageuploaded(res) {
                // console.log('imageuploaded',res)
                if (res.status !== 200)
                    return this.$dialog.error(res.msg || "Upload picture failed");
                this.$dialog.loading.open('loading...')
                this.updata = res.data.url
            },

            copyLink: function () {
                let copybtn = document.getElementsByClassName("copy-data");
                const clipboard = new ClipboardJS(copybtn);
                clipboard.on("success", () => {
                    this.$dialog.success("Salin berhasil");
                });
                clipboard.on("error", res => {
                    this.$dialog.success("Copy error" + res);
                });
            },
            getInfo: function () {
                let that = this;
                getUser().then(
                    res => {
                        that.userInfo = res.data;
                        that.is_promoter = res.data.is_promoter
                        // that.linkText = "I'm in interesting mall shopping 200% Cashback, \n' would like to invite you to participate in:\n" + res.data.shortlink
                        that.linkText = "Bagikan situs penghasil uang yang telah beroperasi selama 3 tahun dan saya masih terus menarik uang " + res.data.shortlink
                        // console.log(that.userInfo);
                    },
                    function (err) {
                        that.$dialog.message(err.msg);
                    }
                );
            },
            toCash: function () {
                this.$router.push({path: "/user/user_cash"});
            }
        }
    };
</script>
<style scoped>
    .frist,
    .second {
        text-align: center;
        padding: 0 0.28rem;
    }

    .hello {
        width: 5rem;

    }

    .btn-wrap {
        display: flex;
        justify-content: space-between;
    }

    .btn {
        width: 3rem;
        height: 1rem;
        border-radius: 3px;
        line-height: 1rem;
        text-align: center;
        font-size: 0.35rem;
        margin: 1rem auto 0.6rem auto;
        border: 1px solid #666;
    }

    .btn-blue {
        color: #fff;
        background: #00c3f9;
        border: 1px solid #00c3f9;

    }

    .T1 {
        font-size: 0.5rem;
        font-weight: bold;
        margin: 0.4rem 0;
    }

    .N1 {
        font-size: 0.3rem;
        color: #333;
        margin: 0rem 0 0.8rem 0;

    }

    .tips {
        font-size: 0.25rem;
        color: #999;
    }
</style>